export class OrderBundleUnitDto {
  constructor(dto) {
    this.id = dto.id;
    this.is_refunded = dto.is_refunded;
    this.product = dto.product;
    this.assignee = dto.assignee;
  }
}

export class OrderBundleDto {
  constructor(dto) {
    this.bundle_id = dto.bundle_id;
    this.package = dto.package;

    /** @type {OrderBundleUnitDto[]} */
    this.units = dto.units;
  }
}
